<template>
  <v-container fluid>
    <v-skeleton-loader
      class="mb-6"
      type="card-avatar, article, list-item-avatar, list-item-avatar"
      v-if="showSkeleton"
    ></v-skeleton-loader>
    <div v-if="!showSkeleton && result != null">
      <v-row>
        <!-- <v-col cols="12" md="10" offset-md="1" lg="10" offset-lg="1" xl="8" offset-xl="2"> -->
        <v-col
          cols="12"
          md="10"
          offset-md="1"
          sm="12"
          lg="10"
          xl="10"
          offset-lg="1"
          offset-xl="1"
        >
          <template v-for="(item, idx) of result.elements">
            <component
              class="mb-10"
              :is="`${$componentIs(item.template)}`"
              :key="`el_${idx}`"
              :content="item"
            ></component>
          </template>

          <template v-if="result.elements.length == 0 && $route.query.q">
            <v-alert width="100%" text color="blue-grey" border="left">
              <div class="headline">No results were found.</div>
              <p class="pt-4">Try different keywords.</p>
            </v-alert>
          </template>
          <template v-if="result.elements.length == 0 && !$route.query.q">
            <v-alert width="100%" text color="teal" border="left">
              <div class="headline">Typing in text box to search</div>
              <p>
                You can search them all such as courses, instructors, tags, categories,
                etc.
              </p>
            </v-alert>
          </template>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { EventBus } from "@/event-bus";
import UnknowComponent from "@/components/UnknowComponent.vue";
// import BannerSlider from "@/components/BannerSlider.vue";
// import CategoryHorizontalListView from "@/components/CategoryHorizontalListView.vue";
// import CourseVerticalGridView from "@/components/CourseVerticalGridView.vue";
import GradeHorizontalListView from "@/components/GradeHorizontalListView.vue";
// import MyCourseVerticalGridView from "@/components/MyCourseVerticalGridView.vue";
import TagListView from "@/components/TagListView.vue";
import TeacherHorizontalListView from "@/components/TeacherHorizontalListView.vue";

import BannerSlider from "@/components/home_v2/NewBannerSlider.vue";
import MyCourseVerticalGridView from "@/components/home_v2/NewMyCourseVerticalGridView.vue";
import CourseVerticalGridView from "@/components/home_v2/NewCourseVerticalGridView.vue";
import CategoryHorizontalListView from "@/components/home_v2/NewCategoryHorizontalListView.vue";
export default {
  components: {
    BannerSlider,
    CategoryHorizontalListView,
    CourseVerticalGridView,
    GradeHorizontalListView,
    MyCourseVerticalGridView,
    TagListView,
    TeacherHorizontalListView,
    UnknowComponent,
  },
  data: () => ({
    result: null,
    loading: false,
    showSkeleton: true,
  }),
  mounted() {
    EventBus.$on("onSearchReload", (q) => {
      this.search(q);
    });
    this.init();
  },
  beforeDestroy() {
    EventBus.$off("onSearchReload");
  },
  methods: {
    init() {
      this.fetch()
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.result = resp.data.result;
          } else {
          }
        })
        .catch((err) => {
          // this.result = null;
        })
        .finally(() => {
          this.showSkeleton = false;
          this.loading = false;
        });
    },
    search(q) {
      this.fetch(q)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.result = resp.data.result;
            console.log(this.result);
          } else {
          }
        })
        .catch((err) => {
          // this.result = null;
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
    fetch(q) {
      if (q == null) {
        q = this.$route.query.q;
      }
      this.showSkeleton = true;
      // console.log("Vue.prototype" ,  Vue.prototype);
      return this.$http.get(`${this.$store.state.api}/list/filter?search=${q}`);
    },
  },
};
</script>
